import {FC} from "react";
import {SurgeryRequestDetailsModalProps} from "./types";
import {Button, Modal} from "antd";
import DetailsWrapper from "./components/details-wrapper/DetailsWrapper";
import {FileProtectOutlined} from "@ant-design/icons";
import "./style.less";

const SurgeryRequestDetailsModal: FC<SurgeryRequestDetailsModalProps> = (props) => {
  const {isDetailsModalOpen, toggleDetailsModal, selectedItem} = props.controller

  return <Modal
    width={920}
    centered
    className="surgery-details-modal"
    title={<div className="surgery-details-modal__title">
      <span className="surgery-details-modal__title-icon"><FileProtectOutlined/></span>
      <span>
        <span className="surgery-details-modal__title-eyebrow">Операційний розклад</span>
        <span className="surgery-details-modal__title-text">Деталі операції</span>
      </span>
    </div>}
    open={isDetailsModalOpen}
    onCancel={toggleDetailsModal}
    footer={<Button className="surgery-details-modal__close" onClick={toggleDetailsModal}>Закрити</Button>}
    destroyOnClose
  >
    <DetailsWrapper data={selectedItem}/>
  </Modal>
}

export default SurgeryRequestDetailsModal
